const LoadingAnimate = () => {
  return (
    <div className="fixed z-2000 bg-[#381967] left-0 right-0 top-0 bottom-0 overflow-hidden">
      <img className="w-[100%] relative top-[50%] -translate-y-[50%]" src='/images/loadingPage2.jpg' alt="" />
      {/* <div className="relative z-10">
        <img className="w-[260px]" src='/images/panda.png' alt="" />
        <img className="w-[140px] mx-auto mt-[36px]" src='/images/bigLogo.png' alt="" />
      </div> */}
    </div>
  );
};

export default LoadingAnimate;
